// JPass网关接口地址;
export const JPassConfig = {
  //唯一标识
  APP_ID: 'japplynzjkiagnj',
  publicKey: "042efc29c326fff631f28e7241a6e17fb8e4d43f8cf266b928dd5769ed3eab2c09f483813a8c8feacf58c96843c8549771763f2fd8e58ca4224770a338dfd36eca",//sm2加密公钥
  privateKey: "00f82c24317585f6e275760614c5ec2e667be1f1765a6a6498eb0eed7591185bd2",//sm2解密公钥
  httpRequestJPaas: "https://jxb.tj.gov.cn/jpaas-jags-server/interface/",
  signUrl: "https://jxb.tj.gov.cn/jpaas-jags-server/interface/createsign.do",//签名接口地址
  gatewayUrl: "https://jxb.tj.gov.cn/jpaas-jags-server/interface/gateway.do",//网关接口地址
  // devUrl: "https://jpaas311.hanweb.com" // 开发环境地址
  devUrl: "https://qf.ningbo.gov.cn"
}